import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-87" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-88" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-89" data-mp="4njnu5x67n8v">
          SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "Montserrat, sans-serif"
      }} data-id="element-90" data-mp="s9zzhikkb8n9">
          MAINTAIN INDEPENDENCE, DIGNITY, AND VITALITY AT HOME
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px",
        fontWeight: "700",
        textAlign: "center"
      }} data-id="element-91" data-mp="382ffxqfwf8fz">
          A comprehensive care system for seniors that improves quality of life through a clinical approach - just 15 minutes a day.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-92" data-mp="399tdd14tkmbt">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-93" data-mp="359j9pv4i2804" />
          <img src="https://cdn.magicpatterns.com/uploads/x2TaJqZiTW9cpxNePraEmZ/ChatGPT_Image_7_sept_2026,_13_41_51.png" alt="The Age-in-Place Blueprint — ebook plus 5 bonuses in digital format" width={1536} height={1024} className="animate-floaty mx-auto aspect-[3/2] w-full max-w-full rounded-2xl object-contain" data-id="element-94" data-mp="2qhqwpps6h61k" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-95" data-mp="s2jjlmv9pier">
          ⭐ 4.9 (500+ satisfied caregivers and families) · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-96" data-mp="degdmdh866py">
          <CTAButton href="#value" data-id="element-97" data-mp="1b0ni7ndj3z2b">See the complete system now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-98" data-mp="1ayji7gir3k7b">
            COMPLETE AGING-IN-PLACE SOLUTION 2026. The #1 system for professional caregivers,
            nurses and families who need a real, evidence-based and ready-to-use protocol to keep
            seniors safe, healthy and independent at home — avoiding expensive residences.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-99" data-mp="3lu9yf4ila4ct">
            Cognitive Health · Physical Strength · Nutrition · Home Safety · Caregiver Wellness ·
            Independence
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-100" data-mp="267wjwkyzvw82">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-101" data-mp="2g0ls96z90tz6">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-102" data-mp="2p0qnkir641wz" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-103" data-mp="2tztu67msqg72">
            Ebook + 5 bonuses · 200+ pages - Everything you need in one place.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-104" data-mp="zlkke0eooxyf">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-105" data-mp="4d73uw8q0vx5">
              <Icon className="h-4 w-4 text-grape" data-id="element-106" data-mp="3vhffa9ghq5ka" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-107" data-mp="e7h93eirhopa">
          🔥 Limited-time offer · Then the price goes back up to $54 USD
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-108" data-mp="3mo2d0gwjdrlj">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-109" data-mp="2yxokkpa1hqqf" />
          25 people are watching this product right now
        </p>
      </div>
    </header>;
}